import {FaRegClock} from "react-icons/fa6";

import {Icon} from "@/components/icon/Icon.tsx";
import {durationSecFn, roundDurationSecs} from "@/lib/format.tsx";
import {PrivateLocationStatus} from "@/lib/types/privatelocations.ts";
import {getLastStatusReportSecsAgo} from "@/pages/monitoring/privatelocations/list/utils.ts";

export interface LastStatusReportCellProps {
  status: PrivateLocationStatus;
}
export const LastStatusReportCell = ({status}: LastStatusReportCellProps) => {
  if (status.sent_at) {
    const lastStatusSecsAgo = getLastStatusReportSecsAgo(status);
    if (lastStatusSecsAgo) {
      return (
        <div className="d-flex align-items-center gap-1 text-nowrap">
          <Icon icon={FaRegClock} /> {durationSecFn(roundDurationSecs(lastStatusSecsAgo))}
        </div>
      );
    }
  }
  return <span className="text-muted">none recorded</span>;
};
